import { Component, Inject, OnInit } from '@angular/core';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';

import { CoachingTranscript } from '../../../../coaching-base/general';
import { useDispatcher, UseStore } from '../../../../store.decorator';
import { BehaviourTag } from '../../model/behaviour-tag.model';

import { TranslationKeyMap } from './behaviour-selection-dialog.i18n';
import { behaviourSelectionDialogReducer } from './behaviour-selection-dialog.reducer';
import { BehaviourSelectionDialogState } from './behaviour-selection-dialog.state';
import { checkboxSelected } from './state/checkbox-selected.action';
import { load } from './state/load.action';

@Component({
    selector: 'cmps-behaviour-selection-dialog',
    templateUrl: './behaviour-selection-dialog.component.html',
    host: {
        class: 'cmps-behaviour-selection-dialog',
    },
})
@UseStore<BehaviourSelectionDialogState>(
    'coaching.behaviourSelectionDialog',
    behaviourSelectionDialogReducer,
)
export class BehaviourSelectionDialogComponent implements OnInit {
    state: BehaviourSelectionDialogState;

    /** @private */
    _i18n = TranslationKeyMap;

    constructor(
        private readonly _dialogRef: CmpsDialogRef<
            BehaviourSelectionDialogComponent,
            BehaviourTag[]
        >,
        @Inject(CMPS_DIALOG_DATA) /** @private */
        readonly _data: CoachingTranscript,
    ) {}

    ngOnInit(): void {
        useDispatcher(
            this,
            load({
                performerId: this._data.attendees?.[0]?.userId,
                focuses: this._data.focuses,
            }),
        );
    }

    /** @private */
    _onBehaviourCheckboxChange(behaviourTag: BehaviourTag): void {
        useDispatcher(
            this,
            checkboxSelected({
                behaviourTag,
            }),
        );
    }

    /** @private */
    _onAddBehavioursClick(): void {
        this._dialogRef.close(this.state.behaviourTagSelection);
    }
}
